<button class="{{ classes }} fx-export-data" (click)="$event.stopPropagation(); $event.preventDefault(); tableToExcel()" create-permission>
  {{ text }}
  <i *ngIf="icon" class="{{ icon }}"></i>
</button>
